module.exports = __webpack_public_path__ + "static/media/ci-grid.73c20ed2.png";